import React from "react";

const StarIcon = ({ filled, color }) => (
  <svg
    viewBox="0 0 20 20"
    className="w-4 h-4"
    fill={filled ? color : "none"}
    stroke={color}
    strokeWidth="1.5"
    aria-hidden="true"
  >
    <path
      strokeLinejoin="round"
      d="M9.05 2.927c.3-.921 1.603-.921 1.902 0l1.518 4.674a1 1 0 0 0 .95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 0 0-.363 1.118l1.518 4.674c.3.92-.755 1.688-1.539 1.118l-3.976-2.888a1 1 0 0 0-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.539-1.118l1.518-4.674a1 1 0 0 0-.363-1.118L1.077 10.1c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 0 0 .951-.69L9.05 2.927Z"
    />
  </svg>
);

const Stars = ({ rating, color = "#FFD23A", count = 5 }) => {
  if (rating == null) return null;
  const value = Math.max(0, Math.min(count, Math.round(rating)));
  return (
    <div className="inline-flex items-center gap-0.5" aria-label={`${value} out of ${count} stars`}>
      {Array.from({ length: count }).map((_, i) => (
        <StarIcon key={i} filled={i < value} color={color} />
      ))}
    </div>
  );
};

export default Stars;
